export function getOfferStatusColor(status) {
    const COLOR_MAP: {[key: string]: any} = {
        "В работе": "#009ACF",
        "Завершен": "#28BA2C",
        "Планируется": "#EEA20E",
        "Запланирован": "#EEA20E",
        "Отменен": "#8797A9",
    }
    return COLOR_MAP[status];
}

export function getOrderCargoStatusColor(status) {
    const COLOR_MAP: {[key: string]: any} = {
        "Новый": "#28BA2C",
        "Завершен": "#28BA2C",
        "Подтвержден автоматически": "#28BA2C",
        "Отменен клиентом": "#E53328",
        "Отклонен портом": "#E53328",
    }
    return COLOR_MAP[status];
}